module.exports = __webpack_public_path__ + "img/8-1_06.fdfd8d7d.jpg";